import { Component } from '@angular/core';
import { SecurityGroup } from './sec-group.model';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { ClientsService } from '../../../services/clients/clients.service';
import { SuperClass } from '../../../superclass/SuperClass';
import { WsService } from '../../../services/websocket/WsService';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-security-groups',
  templateUrl: './security-groups.component.html',
  styleUrls: ['./security-groups.component.css'],
})
export class SecurityGroupsComponent extends SuperClass {
  securityGroups: SecurityGroup[];
  selectedRow: SecurityGroup;
  newSecurityGroup: SecurityGroup;

  display = false;
  newSecurityGroupForm: FormGroup;
  selectedRowForm: FormGroup;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      {
        label: 'Security Groups',
        routerLink: [{ outlets: { sub: [RouterConst.ANALYTICS_GROUPS] } }],
      },
    ]);
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData() {
    this.http_getAllSecurityGroups((data: any) => {
      this.securityGroups = data.payload;
    });

    this.selectedRowForm = this.fb.group({
      securityGroupId: new FormControl('', Validators.required),
      inactiveSessionTimeLimit: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
        ]),
      ),
    });

    this.newSecurityGroupForm = this.fb.group({
      securityGroupId: new FormControl('', Validators.required),
      inactiveSessionTimeLimit: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
        ]),
      ),
    });
  }

  selectRow(e) {
    this.selectedRow = new SecurityGroup(e.data);
  }

  checkGroup(e, str) {
    Object.keys(this.selectedRow.menu).filter(el => {
      const currCheckboxArr = el.toString().startsWith(str);
      if (currCheckboxArr) {
        this.selectedRow.menu[el].allowed = !!e;
      }
    });
  }

  addNewSecurityGroup() {
    this.display = true;
    this.newSecurityGroup = new SecurityGroup();
  }

  createSecurityGroup() {
    // const requiredFields = [
    //   {id: 'new_security_group_id', value: this.newSecurityGroup.name, fieldName: 'Security Group'},
    //   {
    //     id: 'new_inactive_session_time_limit',
    //     value: this.newSecurityGroup.inactive_session_time_limit,
    //     fieldName: 'Inactive Session Time Limit'
    //   }
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_createNewSecurityGroup(this.newSecurityGroup, (data: any) => {
      this.showSuccessMessage('Security Group has been created');
      this.unselectRow();
      this.securityGroups = data.payload;
    });
    this.display = false;
  }

  saveChanges() {
    this.http_updateSecurityGroup(this.selectedRow, (data: any) => {
      this.showSuccessMessage('Security Group has been updated');
      this.unselectRow();
      this.securityGroups = data.payload;
    });
  }

  deleteSecurityGroup() {
    this.http_deleteSecurityGroup({ id: this.selectedRow.id }, (data: any) => {
      this.showSuccessMessage('Security Group has been deleted');
      this.unselectRow();
      this.securityGroups = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/security-groups/security-groups.component.ts